import { createContext, FC, PropsWithChildren, ReactNode, useContext, useMemo, useState } from 'react';
import { Filter, initialFilters } from 'src/domain';

export const FilterContext = createContext<[Filter, React.Dispatch<React.SetStateAction<Filter>>]>([
    initialFilters,
    () => {
        return undefined;
    },
]);
export const useFilterContext = () => useContext(FilterContext);

export const FilterContextProvider: FC<PropsWithChildren<unknown>> = ({ children }: { children?: ReactNode }) => {
    const [filterState, setFilterState] = useState(initialFilters);
    const defaultFilterContext: [Filter, typeof setFilterState] = useMemo(
        () => [filterState, setFilterState],
        [filterState]
    );

    return <FilterContext.Provider value={defaultFilterContext}>{children}</FilterContext.Provider>;
};
